import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImportProductsFromCsvService } from '@spartacus/cart/import-export/components';
import { ImportExportConfig } from '@spartacus/cart/import-export/core';
import { ImportCsvFileService } from '@spartacus/storefront';
import { SimpleEntry } from '../../../../../../core/models/orderEntry.model';
import { DragAndDropService } from '../../../../../../components/drag-and-drop/drag-and-drop.service';
import {
  DragAndDropConfigs,
  DragAndDropFile,
  DragAndDropValidation,
} from '../../../../../../components/drag-and-drop/core/drag-and-drop.model';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'import-entries',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, I18nModule],
  templateUrl: './import-entries.component.html',
  styleUrl: './import-entries.component.scss',
})
export class ImportEntriesComponent {
  @Output() _onChangeFile = new EventEmitter<SimpleEntry[]>();
  @Input() validation: DragAndDropValidation = this.dragAndDropService.validateFiles.bind(this.dragAndDropService);

  @Input() configs: DragAndDropConfigs = {
    maxFiles: 1,
    maxFileSize: 25 * 1024 * 1024, // 5MB
    allowedFileTypes: ['csv'],
  };

  @Input() form: FormGroup = this.fb.group({
    upload: ['', []],
  });

  constructor(
    private fb: FormBuilder,
    private importExportConfig: ImportExportConfig,
    protected importCsvFileService: ImportCsvFileService,
    protected importProductsFromCsvService: ImportProductsFromCsvService,
    protected dragAndDropService: DragAndDropService,
    private toasterService: ToasterService,
  ) {}

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const file: File | null = target.files ? target.files[0] : null;

    if (file) {
      const items: DragAndDropFile[] = [...[file].map(file => ({ file, errors: [] as any[] }))];
      const validation = this.validation(items, this.configs);
      let hasError = false;

      validation.items?.forEach(item => {
        item.errors.forEach(error => {
          this.toasterService.displayError(error.message);
          hasError = true;
        });
      });

      if (hasError) {
        return;
      }

      if (this.separator !== undefined) {
        this.importCsvFileService.loadFile(file, this.separator).subscribe((loadedFile: string[][]) => {
          const simpleEntries: SimpleEntry[] = this.importProductsFromCsvService
            .csvDataToProduct(loadedFile)
            .map(entry => ({
              code: entry.productCode,
              qty: entry.quantity,
            }));

          this._onChangeFile.emit(simpleEntries);
        });
      }
    }
  }

  protected get separator(): string | undefined {
    return this.importExportConfig.cartImportExport?.file.separator;
  }
}
